// @flow

import React from 'react';

import {
  BaseUserAvatar,
  getUserTitle,
  getUserTooltipItemName,
} from './BaseUserAvatar';
import {
  MultipleBaseAvatar,
  SingleAvatarAdditionalProps,
} from './MultipleBaseAvatar';
import {AvatarTooltipsProps} from './tooltips';
import {BasicMaybeTaskUserSerializedType} from './user-type';
import {UserAvatar} from './UserAvatar';

interface Props extends AvatarTooltipsProps {
  className?: string;
  users: Array<BasicMaybeTaskUserSerializedType>;
  tooltipListLimit?: number;
}

export function MultipleUsersAvatar({
  users,
  className,
  tooltipPlacement,
  tooltipTitle,
  tooltipListLimit,
}: Props): JSX.Element {
  return (
    <MultipleBaseAvatar
      items={users}
      renderItemAvatar={renderUserAvatar}
      renderItemTooltipText={(user) =>
        getUserTooltipItemName(
          getUserTitle(user),
          'is_guest_until' in user ? user.is_guest_until : undefined
        )
      }
      serializeItem={serializeUser}
      getItemId={(user) => user.id}
      className={className}
      tooltipPlacement={tooltipPlacement}
      tooltipTitle={tooltipTitle}
      tooltipListLimit={tooltipListLimit}
      circle={true}
    />
  );
}

const serializeUser = (user: BasicMaybeTaskUserSerializedType) =>
  [user.name, user.id, user.email, user.avatar_image].join('|');

const renderUserAvatar = <U extends BasicMaybeTaskUserSerializedType>(
  user: U,
  {multiple, ...props}: SingleAvatarAdditionalProps
) =>
  multiple ? (
    <BaseUserAvatar user={user} {...props} multiple={true} />
  ) : (
    <UserAvatar user={user} {...props} />
  );
